import Main from './components/main';
import ClearCache from 'react-clear-cache';
import './App.css';

function App(props) {
  if (process.env.NODE_ENV !== "development") 
  {
    console.log = () => {};
  }
  caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
  return (
    <ClearCache duration={5000}>
    {({ isLatestVersion, emptyCacheStorage }) => {
      console.log(isLatestVersion, "isLatestVersion")
      if(!isLatestVersion) {
        emptyCacheStorage();
      }
      return(
    <div>
        <Main {...props}/>
    </div>
    )
  }}
  </ClearCache>
  );
}

export default App;
